<h1 mat-dialog-title>Form W-9 Information</h1>
<div mat-dialog-content>
  <div>
    <form [formGroup]="formW9" autocomplete="off">
      <mat-form-field 
        appearance="outline"
        style="width: 100%;">
        <mat-label>Full name</mat-label>
        <input matInput autocomplete="off"
          placeholder="Full name of payee"
          maxLength="100"
          id="w9FullName"
          name="w9FullName"
          formControlName="w9FullName">
          <mat-error 
            *ngIf="onCheckW9ControlValidators('w9FullName')">
            Full name is required
          </mat-error>
          <mat-hint *ngIf="formW9.get('w9FullName').value && formW9.get('w9FullName').value.length >= 100">
            100 character limit
          </mat-hint>
      </mat-form-field>
      <mat-form-field 
      appearance="outline"
      style="width: 100%;">
      <mat-label>SSN/ITIN</mat-label>
      <input matInput autocomplete="off"
        [hiddenInput]="true"
        mask="XXX-XX-0000"
        placeholder="Social Security Number or ITIN"
        id="w9Ssn"
        name="w9Ssn"
        (keyup)="onChangeW9Ssn($event)"
        formControlName="w9Ssn">
        <mat-error 
          *ngIf="onCheckW9ControlValidators('w9Ssn')">
          SSN/ITIN is required
        </mat-error>
        <mat-hint *ngIf="formW9.get('w9Ssn').value && formW9.get('w9Ssn').value.length > 11">
          9 character limit
        </mat-hint>
        <mat-hint *ngIf="readOnlySsnLast4">
          Enter new value to update SSN/ITIN
        </mat-hint>
    </mat-form-field>
      <div style="margin-top: 15px;" >
    
        <mat-label> <strong>Mailing address</strong></mat-label>
      <address>{{data.w9AddressStreet}}<br>
      {{data.w9AddressCity}}, {{data.w9AddressState}} {{data.w9AddressZip}}<br>
      
      </address>
      
    </div>
     

      <div *ngIf="readOnlySsnLast4" style="height: 9px;"></div>

      <mat-checkbox style="margin-left: 3px; font-size: 14px;"
        id="confirmReviewedTerms"
        name="confirmReviewedTerms"
        (change)="onChangeEventTerms($event)"
        formControlName="confirmReviewedTerms">
        Under penalties of perjury, I certify that: 
      </mat-checkbox>
      <ul>
        <li style="font-size: 14px;">
          The number entered  is my correct taxpayer identification number/SSN (or I am waiting for a number to be issued to me);   
        </li>
        <li style="font-size: 14px;">
         The mailing address is my correct mailing address; and 
        </li>
        <li style="font-size: 14px;">
          I am a U.S. citizen or other U.S. person 
        </li>
      </ul>

      <div *ngIf="!formW9.pristine && !formW9.invalid">
        <small>Authorized on {{currentDate.toLocaleDateString("en-US")}}</small>
      </div>
      <div *ngIf="innerHeight > 667" mat-dialog-actions style="margin-top: 18px !important; float: right !important;">
        <button mat-button
          (click)="onClickCancel()">
          CANCEL
        </button>
        <button mat-flat-button
          (click)="onSave()"
          color="primary"
          [disabled]="formW9.pristine || formW9.invalid">
          SAVE
        </button>
      </div>
      <div *ngIf="innerHeight <= 667" mat-dialog-actions style="margin-top: 18px !important;">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <button mat-button
          (click)="onClickCancel()">
          CANCEL
        </button>
        <button mat-flat-button
          (click)="onSave()"
          color="primary"
          [disabled]="formW9.pristine || formW9.invalid">
          SAVE
        </button>
      </div>
    </form>
  </div>

</div>

